import React from "react";
import ConfirmPopup from "../../ConfirmPopup";
import { AlertNotification, H2, Text, fontFamilies } from "@commonsku/styles";
import { CatalogItem } from "../../../types";


interface CatalogUnpublishPopupProps {
    item: CatalogItem | null;
    unpublishing?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const CatalogUnpublishPopup = ({
    item,
    unpublishing = false,
    onCancel,
    onConfirm,
}: CatalogUnpublishPopupProps) => {
    if (!item) {
        return null;
    }

    return (
        <ConfirmPopup
            cancelLabel="Cancel"
            confirmLabel="Unpublish"
            confirmLoading={unpublishing}
            onClose={onCancel}
            onConfirm={onConfirm}
        >
            <>
                <H2 style={{
                    marginBottom: 16,
                    width: "100%",
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 1,
                }}>Unpublish {item.item_name}</H2>
                <AlertNotification alertType="warn">
                    <Text color="secondary2" style={{ fontFamily: fontFamilies.skuFontMedium }}>
                    This product will be removed from your published catalog and will no longer be available to sales reps.
                    If this product is connected to external systems, unpublishing may cause disruptions depending on how it's been used.
                    All product data is preserved. You can re-publish at any time.
                    </Text>
                </AlertNotification>
            </>
        </ConfirmPopup>
    );
};
